
export default function PostIcons(props){
    return(
        <span>{props.icone} </span>
    )
}